import { render, staticRenderFns } from "./BusinessPartnerAdd.vue?vue&type=template&id=2bfa58b5"
import script from "./BusinessPartnerAdd.vue?vue&type=script&lang=ts"
export * from "./BusinessPartnerAdd.vue?vue&type=script&lang=ts"
import style0 from "./BusinessPartnerAdd.vue?vue&type=style&index=0&id=2bfa58b5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports